import { KebabMenu, KebabMenuItem } from '@library/components/menus';
import CheckIcon from '@library/assets/images/icons/checked-icon.svg';
import Goblin from '@library/assets/images/icons/goblin.png';
import PersonIcon from '@library/assets/images/icons/person-icon.svg';
import type { PromotionPendingApprovalActionsVisibleMenuItems } from '@library/types/promotions';
import { classNames } from '@library/utils';
import { useMemo } from 'react';

export interface PromotionPendingApprovalActionsKebabMenuProps {
  menuItemsClassName?: string;
  onShowApprovalModal: () => void;
  onViewPromotionClick: () => void;
  visibleMenuItems: PromotionPendingApprovalActionsVisibleMenuItems;
}

export interface PromotionPendingApprovalActionsMenuItem {
  handleOnClick: () => void;
  message: string;
  icon: string;
  iconClassName?: string;
  showMenuItem?: boolean;
}

export const PromotionPendingApprovalActionsKebabMenu = ({
  menuItemsClassName = '',
  onShowApprovalModal,
  onViewPromotionClick,
  visibleMenuItems
}: PromotionPendingApprovalActionsKebabMenuProps) => {
  const { approve, viewPromotion, viewPromoUsers } = visibleMenuItems;

  const menuItems = useMemo<Array<PromotionPendingApprovalActionsMenuItem>>(
    () => [
      {
        handleOnClick: () => onShowApprovalModal(),
        message: 'Approve',
        icon: CheckIcon,
        iconClassName: 'mb-[0.5px]',
        showMenuItem: approve
      },
      {
        handleOnClick: () => onViewPromotionClick(),
        message: 'View Promotion',
        icon: Goblin, // TODO: request icon from back-office design
        showMenuItem: viewPromotion
      },
      {
        // eslint-disable-next-line no-console
        handleOnClick: () => console.log('view promo users'),
        message: 'View Promo Users',
        icon: PersonIcon,
        showMenuItem: viewPromoUsers
      }
    ],
    [
      approve,
      onShowApprovalModal,
      onViewPromotionClick,
      viewPromoUsers,
      viewPromotion
    ]
  );

  const MenuItems = () => {
    const items: Array<JSX.Element> = [];

    menuItems.forEach((menuItem) => {
      const {
        handleOnClick,
        icon,
        iconClassName = '',
        message,
        showMenuItem = true
      } = menuItem;

      if (!showMenuItem) {
        return;
      }

      items.push(
        <KebabMenuItem
          key={message}
          className="text-soClean-100 hover:bg-soFresh-140 flex h-10 w-full items-center justify-between px-2 pl-3"
          handleOnClick={handleOnClick}
        >
          <span>{message}</span>
          <img
            alt={message}
            className={classNames('size-4', iconClassName)}
            src={icon}
          />
        </KebabMenuItem>
      );
    });

    return items;
  };

  return (
    <KebabMenu
      className="relative size-6"
      menuButtonClassName="self-center"
      menuItemsClassName={classNames(
        'border border-soFresh-140 bg-soFresh-110 z-10 right-0 text-xs w-40 rounded-md bottom-[-1rem] right-7',
        menuItemsClassName
      )}
      menuButtonOpenClassName="rounded-md bg-soFresh-140"
      title="UserKebabMenu"
      testId="promotion-pending-approval-menu"
    >
      <p className="text-soClean-100 cursor-default p-2 font-bold">Actions</p>
      <MenuItems />
    </KebabMenu>
  );
};
